module.exports = __webpack_public_path__ + "static/img/2.72f188d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/2.png
// module id = IKki
// module chunks = 0